import*as e from"react";var f="undefined"!=typeof window?e.useLayoutEffect:e.useEffect;export{f as default};
//# sourceMappingURL=useEnhancedEffect.js.map
